module.exports = __webpack_public_path__ + "static/umeh-91933a2ebc7bb64b5d9bae1f3fdb430f.png";